import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';
import '@campact/camper/core/CmprTicker';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

import StickyTickerController from '@cta/donate_call_component/controllers/sticky_ticker_controller';

import Rails from '@rails/ujs';
import { Application } from '@hotwired/stimulus';
import { installErrorHandler } from '@appsignal/stimulus';
import appsignal from '@/shared/appsignal';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('sticky-ticker', StickyTickerController);

AppBoot.start(App);
